/* Gorgias chat extras (gorgias-chat-controls-jul13)
 *
 * 1. Any <a href="…#live-chat"> or [data-gorgias-open] click opens the Gorgias
 *    chat window (footer "Live Chat" entry, contact-page button).
 * 2. Injects a small "×" above the floating chat bubble that hides the widget
 *    for the rest of the session (it overlaps shopping buttons on mobile).
 *
 * Gorgias loads as a Shopify app embed; everything here is a safe no-op when
 * the widget is absent (e.g. the dev store).
 */
(function () {
  'use strict';

  var HIDDEN_KEY = 'gf-gorgias-hidden';
  var HIDDEN_CLASS = 'gf-gorgias-hidden';

  function isHidden() {
    try { return sessionStorage.getItem(HIDDEN_KEY) === '1'; } catch (e) { return false; }
  }

  function setHidden(hidden) {
    try {
      if (hidden) sessionStorage.setItem(HIDDEN_KEY, '1');
      else sessionStorage.removeItem(HIDDEN_KEY);
    } catch (e) { /* storage unavailable: hide still applies for this page */ }
    document.documentElement.classList.toggle(HIDDEN_CLASS, hidden);
  }

  /* -- 1. open-chat links ------------------------------------------------ */

  function openChat(attemptsLeft) {
    var chat = window.GorgiasChat;
    if (chat && typeof chat.open === 'function') {
      setHidden(false); // links must work even after the bubble was dismissed
      chat.open();
      return;
    }
    if (attemptsLeft > 0) {
      setTimeout(function () { openChat(attemptsLeft - 1); }, 250);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href$="#live-chat"], [data-gorgias-open]');
    if (!trigger) return;
    event.preventDefault();
    openChat(20); // retry ~5s in case the embed is still loading
  });

  /* -- 2. dismiss control ------------------------------------------------ */

  if (isHidden()) setHidden(true);

  var pollMs = 500;
  var pollBudget = 30000;

  function placeDismiss(bubble) {
    if (document.querySelector('.gf-gorgias-hide')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gf-gorgias-hide';
    btn.setAttribute('aria-label', 'Hide chat button');
    btn.innerHTML = '<span aria-hidden="true">&times;</span>';

    // sit just above the bubble, right-aligned to it; the bubble can move
    // (campaign bubbles, preview bar, viewport changes) so keep tracking it
    function position() {
      var rect = bubble.getBoundingClientRect();
      if (rect.height === 0) return; // bubble not laid out right now
      // the visible circle is inset inside the iframe, so overlap the frame
      // edge to sit snug at the icon's top-right shoulder, shifted right by
      // 14% of the bubble width so it hangs off the icon's edge
      btn.style.right = Math.max(window.innerWidth - rect.right + 4 - rect.width * 0.14, 4) + 'px';
      btn.style.bottom = Math.max(window.innerHeight - rect.top - 12, 8) + 'px';
    }
    position();
    window.addEventListener('resize', position);
    setInterval(position, 2000);

    btn.addEventListener('click', function () { setHidden(true); });
    document.body.appendChild(btn);
    requestAnimationFrame(function () { btn.classList.add('is-visible'); });
  }

  function waitForBubble() {
    // existence, not visibility: the widget may load while session-hidden,
    // and the × must be ready for when a live-chat link un-hides it
    var bubble = document.querySelector('#gorgias-chat-container iframe#chat-button');
    if (bubble) {
      placeDismiss(bubble);
      return;
    }
    pollBudget -= pollMs;
    if (pollBudget > 0) setTimeout(waitForBubble, pollMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForBubble);
  } else {
    waitForBubble();
  }
})();
